module.exports = __webpack_public_path__ + "static/media/header.6c802b30.webp";